<template>
  <div class="movie-details">
    <!-- Hero Section with Poster Background -->
    <div
      class="hero"
      :style="{ backgroundImage: `url(${posterUrl})` }"
    >
      <div class="overlay">
        <h1>{{ movie?.title }}</h1>
        <p class="rating" v-if="movie?.vote_average">
          ⭐ {{ movie.vote_average.toFixed(1) }}/10
        </p>
      </div>
    </div>

    <!-- Back Button Row -->
    <div class="back-container">
      <button @click="goHome" class="back-btn">⬅ Back</button>
    </div>

    <!-- Movie Details -->
    <div class="details-container" v-if="movie">
      <div class="poster">
        <img :src="posterUrl" :alt="movie.title" />
      </div>

      <div class="info">
        <p class="overview">{{ movie.overview }}</p>

        <h3>Trailer</h3>
        <div class="trailer" v-if="trailerKey">
          <iframe
            :src="`https://www.youtube.com/embed/${trailerKey}`"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
        <p v-else>No trailer available.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      movie: null,
      trailerKey: null
    };
  },
  computed: {
    posterUrl() {
      return this.movie?.poster_path
        ? `https://image.tmdb.org/t/p/w1280${this.movie.poster_path}`
        : "https://via.placeholder.com/1280x720?text=No+Image";
    }
  },
  methods: {
    goHome() {
      this.$router.push({ path: "/" });
    }
  },
  async mounted() {
    const apiKey = "032df6282bf9cdfb83732001903e8c27";

    const movieRes = await fetch(
      `https://api.themoviedb.org/3/movie/${this.$route.params.id}?api_key=${apiKey}&language=en-US`
    );
    this.movie = await movieRes.json();

    const trailerRes = await fetch(
      `https://api.themoviedb.org/3/movie/${this.$route.params.id}/videos?api_key=${apiKey}&language=en-US`
    );
    const trailerData = await trailerRes.json();
    const trailer = trailerData.results.find(
      v => v.type === "Trailer" && v.site === "YouTube"
    );
    this.trailerKey = trailer ? trailer.key : null;
  }
};
</script>

<style scoped>
.movie-details {
  color: white;
}

/* Hero Background */
.hero {
  height: 300px;
  background-size: cover;
  background-position: center;
  position: relative;
}

.overlay {
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 20px;
}

.overlay h1 {
  font-size: 2.5rem;
  margin: 0;
}

.rating {
  font-size: 1.2rem;
  margin-top: 5px;
  color: gold;
}

/* Back Button Row */
.back-container {
  position: relative;
  z-index: 2;
  background-color: #121212;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.back-btn {
  background-color: #ff5555;
  border: none;
  padding: 10px 15px;
  border-radius: 6px;
  color: white;
  cursor: pointer;
  font-size: 1rem;
}

.back-btn:hover {
  background-color: #cc0000;
}

/* Details Layout */
.details-container {
  display: flex;
  gap: 30px;
  padding: 20px;
  flex-wrap: wrap;
}

.poster img {
  width: 300px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4);
}

.info {
  flex: 1;
  min-width: 300px;
}

.overview {
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 20px;
}

.trailer iframe {
  width: 100%;
  height: 315px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4);
}

@media (max-width: 768px) {
  .poster img {
    width: 100%;
  }
}
</style>

